import { BrProductSlotter, MSG_TYPE } from './BrProductSlotter';

BrProductSlotter.MSG_TYPE = MSG_TYPE;
export default BrProductSlotter;
